import { makePublicUrl } from 'app/utils/publicUrl'
import CompanyImage from 'components/Image/CompanyImage'
import { DomainType } from 'features/domains/types'
import {
  ReviewDealerNameCellContainter,
  ReclaimLicenseContentTitle,
} from '../../styles'

interface ReviewDealerNameCellProps {
  dealer: DomainType
}

function ReviewDealerNameCell({ dealer }: ReviewDealerNameCellProps) {
  return (
    <ReviewDealerNameCellContainter>
      <CompanyImage
        mini
        src={
          dealer.imageUrl || makePublicUrl('images/defaultRootDomainIcon.svg')
        }
      />
      <ReclaimLicenseContentTitle>{dealer.name}</ReclaimLicenseContentTitle>
    </ReviewDealerNameCellContainter>
  )
}

export default ReviewDealerNameCell
